<div class="redefinicao__senha">
    <div class="redefinicao__senha__container">
        <p class="redefinicao__voltar" (click)="voltarParaHome()">
            <img class="icone__voltar" src="assets/images/icons/voltar.png">Lembrei
        </p>
        <div class="card__container">
            <p class="container__titulo">Redefinição de senha</p>
            <div class="container__descricao">
                <p class="descricao__texto">
                    Confirme seu CPF e crie sua nova senha.
                </p>
            </div>
            <form [formGroup]="membroForm" (ngSubmit)="onSubmit()">
                <!-- CPF -->
                <div class="lovers-input__container">
                    <input type="text" class="lovers-input input__style" pattern="[0-9]*" inputmode="numeric"
                        placeholder="CPF" mask="000.000.000-00" name="cpf" formControlName="cpf">
                    <div *ngIf="validation_cpf.invalid && (validation_cpf.dirty || validation_cpf.touched)">
                        <label *ngIf="validation_cpf.errors.required" class="text-danger font_error">
                            Campo obrigatorio
                        </label>
                    </div>
                </div>

                <!-- NOVA SENHA -->
                <div class="lovers-input__container">
                    <div class="input__senha">
                        <input [type]="tipoInput" class="lovers-input input__style" placeholder="Nova senha"
                            name="senha" formControlName="senha" (keyup)="validarCoincidenciaSenhas()">
                        <div class="icone__alteracao-tipo">
                            <img class="opcao__icone" [src]="iconeSenha" (click)="alterarTipoInput(1)" />
                        </div>
                    </div>
                    <div *ngIf="validation_senha.invalid && (validation_senha.dirty || validation_senha.touched)">
                        <label *ngIf="validation_senha.errors.required" class="text-danger font_error">
                            Campo obrigatorio
                        </label>
                        <!-- <label *ngIf="validation_senha.errors.pattern" class="text-danger font_error">
                            A senha fornecida não corresponde às restrições exigidas
                        </label> -->
                    </div>
                    <div class="password__validation">
                        <app-validete-password [valuePassword]="membroForm.controls['senha'].value" />
                    </div>
                </div>

                <!-- CONFIRMACAO SENHA -->
                <div class="lovers-input__container">
                    <div class="input__senha">
                        <input [type]="tipoInputConfirmar" class="lovers-input input__style"
                            placeholder="Confirmar senha" name="senhaConfirmacao" formControlName="senhaConfirmacao"
                            (keyup)="validarCoincidenciaSenhas()">
                        <div class="icone__alteracao-tipo">
                            <img class="opcao__icone" [src]="iconeConfirmarSenha" (click)="alterarTipoInput(2)" />
                        </div>
                    </div>
                    <div
                        *ngIf="validation_senhaConfirmacao.invalid && (validation_senhaConfirmacao.dirty || validation_senhaConfirmacao.touched)">
                        <label *ngIf="validation_senhaConfirmacao.errors.required" class="text-danger font_error">
                            Campo obrigatorio
                        </label>
                    </div>
                </div>
                <div class="password__validation">
                    <p class="mb-2 ml-1 font-14 label-sem-validacao" id="item-5">
                        <i class="fa fa-check"></i> Senha coincidente
                    </p>
                </div>
                <!-- BOTÃO SUBMIT -->
                <div>
                    <input [disabled]="membroForm.invalid" type="submit" value="Enviar" class="lovers-button">
                </div>
                <!-- </div> -->
            </form>
        </div>
        <img src="assets/images/backgrounds/background-novaSenha.png" class="background__image" />
        <img src="assets/images/backgrounds/background-novaSenha-mobile.png" class="background__image-mobile" />
    </div>
</div>